import { getUserInfo } from './Common.utils';
import InactivityHandler from './InactivityHandler';

export default function InactivityController() {
  const oidcUser = getUserInfo();

  if (!oidcUser) {
    return null;
  }

  return <InactivityHandler />;
}
